module.exports = __webpack_public_path__ + "06b7d83d6f62a77f5d8c7800b025f1dc.jpg";